import { en, nl } from '@nuxt/ui/locale'
import { siteName } from '~/constants/site'

export default async function () {
  const { locale } = useI18n()

  const appLocale = computed(() => {
    if (locale.value === 'en')
      return en

    if (locale.value === 'nl')
      return nl

    return nl
  })

  const lang = computed(() => appLocale.value.code)
  const dir = computed(() => appLocale.value.dir)

  useHead({
    title: 'Home',
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
    link: [
      { rel: 'icon', href: '/favicon.ico' },
    ],
    htmlAttrs: {
      lang,
      dir,
    },
  })

  useSeoMeta({
    titleTemplate: `%s | ${siteName}`,
    ogSiteName: siteName,
    twitterCard: 'summary_large_image',
  })

  return {
    lang,
    locale: appLocale,
  }
}
